export default "__VITE_ASSET__KcpF1b7m__"